import { Typography, Card, Stack } from "@mui/material";
import myData from '../Data/about.json'
import useIsMobile from "../AppHelpers";

const AboutCard = ()=> {
  const isMobile = useIsMobile()

  
  const getAllowedWidth =()=>{
    return isMobile ? '100vw':'50vw'
  }
  
  return (
      
      <Card id='about' className="AboutCard" raised={true} sx={{backgroundColor:'#420A02', width:{getAllowedWidth}, padding:'2rem', margin:'2rem',textAlign:'left'}}>
        <Typography variant="h3" className='mb-0' align={'left'} sx={{color: '#fff'}}>About</Typography>
        <Stack direction={'column'} sx={{backgroundColor:"antiqueWhite", color:'#420A02',padding:'2rem', width:'100%', }}>
            <Typography variant="h4">{myData.title}</Typography>
                    <br/>
                    <Typography variant="h5">{myData.subject_header}</Typography>
                    <Typography variant="body2" fontFamily={'Helvetica Neue'}>{myData.subject}</Typography>
                    <br/>
                    <Typography variant="h5">{myData.subject_2_header}</Typography>
                    <Typography variant="body2" fontFamily={'Helvetica Neue'}>{myData.subject_2}</Typography>
                    <br/>
                    <Typography variant="h5">{myData.subject_3_header}</Typography>
                    <Typography variant="body2" fontFamily={'Helvetica Neue'}>{myData.subject_3}</Typography>
        </Stack>
      </Card>
    );
  }
  
  export default AboutCard;